<template>
<div class="chapter">
<div class="inner_page">
<p class="fm-head">Contents</p>
<p class="toc"><a href="#/Acknowledgements">Acknowledgements</a></p>
<p class="toc"><a href="#/Introduction">Introduction</a></p>
<p class="toc1"><span href="#/Chapter1" title="Link target outside of Sample">1. From Saloons to Fine Dining: A Brief History of the Culinary and Cultural Scene in Tucson</span></p>
<p class="toc"><span href="#/Chapter2" title="Link target outside of Sample">2. Early Eats: 1920s–1930s</span></p>
<p class="toc"><span href="#/Chapter3" title="Link target outside of Sample">3. Bigger Bites: 1940s–1950s</span></p>
<p class="toc1"><span href="#/Chapter3#C3-1" title="Link target outside of Sample">T<span class="small">HOSE</span> S<span class="small">TEAK</span> J<span class="small">OINTS</span></span></p>
<p class="toc"><span href="#/Chapter3#C3-2" title="Link target outside of Sample">T<span class="small">HE</span> B<span class="small">EST</span> 23 M<span class="small">ILES OF</span> M<span class="small">EXICAN</span> F<span class="small">OOD</span></span></p>
<p class="toc1"><span href="#/Chapter4" title="Link target outside of Sample">4. The Times and Tastes Were A-changin’: 1960s–1970s</span></p>
<p class="toc1"><span href="#/Chapter4#C4-1" title="Link target outside of Sample">H<span class="small">ISTORIC</span> F<span class="small">OURTH</span> A<span class="small">VENUE</span></span></p>
<p class="toc1"><span href="#/Chapter5" title="Link target outside of Sample">5. If You Can’t Find It Here: 1980s and Beyond</span></p>
<p class="toc"><span href="#/Chapter6" title="Link target outside of Sample">6. Let’s See What Tomorrow Brings</span></p>
<p class="toc1"><span href="#/Bibliography" title="Link target outside of Sample">Bibliography</span></p>
<p class="toc"><span href="#/Author" title="Link target outside of Sample">About the Author</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Contents.vue?526cebbe